import * as constants from '../constants';
import { createReducer } from '../../../utils';

const initialState = {
  aboutUsData: {},
  draftImageData: {
    scannedPhotoUrl: '',
  },
  delete: false,
  hasRegisteredChanges: false,
};

export default createReducer(initialState, {
  [constants.SET_ABOUT_US_DATA]: (state, { aboutUsData, hasRegisteredChanges = true }) => ({
    ...state, aboutUsData, hasRegisteredChanges,
  }),
  [constants.RESET_INTRO_CHANGES_FLAG]: (state) => ({
    ...state, hasRegisteredChanges: false, delete: false,
  }),
  [constants.SET_ABOUT_US_PHOTO_S3_SCANNED_URI]: (state, { scannedPhotoUrl }) => ({
    ...state, draftImageData: { ...state.draftImageData, scannedPhotoUrl }, hasRegisteredChanges: true,
  }),
  [constants.DELETE_ABOUT_US]: (state) => ({
    ...state,
    aboutUsData: {
      headline: '',
      quote: '',
      body: '',
      img: null,
      product_id: null,
      type: null,
    },
    draftImageData: {
      scannedPhotoUrl: '',
    },
    hasRegisteredChanges: true,
    delete: true,
  }),
});
